import { api } from '@/shared/api';
import type { AppDispatch } from '@/app/store';

export type SessionCheckResult = 'ok' | 'unauthorized' | 'unavailable';

/**
 * Проверяет сохранённую сессию запросом /v3/users/current.
 * Протухший access обменивается прозрачно в baseQueryWithAuth; 401 после
 * рефреша — сессия мертва. Сетевые ошибки и 5xx токены не трогают.
 */
export async function validateSession(
  dispatch: AppDispatch
): Promise<SessionCheckResult> {
  try {
    await dispatch(
      api.endpoints.getCurrentUser.initiate(undefined, { forceRefetch: true })
    ).unwrap();
    return 'ok';
  } catch (err) {
    const status = (err as { status?: number | string } | undefined)?.status;
    if (status === 401 || status === 403) return 'unauthorized';
    return 'unavailable';
  }
}
